import { Action } from '../actions';
import {
    UPDATE_INITIAL_FREELANCER_DATA,
    VALIDATE_FREELANCER_CARD_EDIT_REGION
} from '../actions/freelancers/freelancer-card-edit';
import { REGIONS_SET_GEOID, REGIONS_SET_SUGGEST_LIST, REGIONS_SET_TEXT } from '../actions/regions';
import { Region, RegionInputIds, RegionsState } from '../typings/regions';
import { State } from '../typings/state';

const initialState = {
    [RegionInputIds.FreelancerRegionInputId]: {
        text: '',
        suggestList: [],
        hasError: false,
        geoId: undefined
    }
};

export function regions(state: RegionsState = initialState, action: Action, fullState: State): RegionsState {
    switch (action.type) {
        case REGIONS_SET_TEXT:
            return {
                ...state,
                [action.regionInputId]: {
                    ...state[action.regionInputId],
                    text: action.text,
                    geoId: undefined
                }
            };

        case REGIONS_SET_SUGGEST_LIST:
            return {
                ...state,
                [action.regionInputId]: {
                    ...state[action.regionInputId],
                    suggestList: action.suggestList
                }
            };

        case REGIONS_SET_GEOID:
            return {
                ...state,
                [action.regionInputId]: {
                    ...state[action.regionInputId],
                    geoId: action.geoId
                }
            };

        case UPDATE_INITIAL_FREELANCER_DATA:
            const { initRegion, regionInputId } = action.payload;

            const { geoId, region, country } = initRegion;
            let textRegion = '';

            if (region && country) {
                textRegion = `${country}, ${region}`;
            }

            return {
                ...state,
                [regionInputId]: {
                    ...state[regionInputId],
                    text: textRegion,
                    geoId
                }
            };

        case VALIDATE_FREELANCER_CARD_EDIT_REGION:
            return {
                ...state,
                [action.regionInputId]: {
                    ...state[action.regionInputId],
                    hasError: !validateRegion(state[action.regionInputId])
                }
            };
        default:
            return state;
    }
}

function validateRegion(region: Region): boolean {
    return Boolean(region.geoId);
}
